import JobService from '@/services/Job.service';

/**
 * Busca os logos das vagas em janela, em vez de todos de uma vez.
 *
 * Por que: os dois carrosseis da home disparavam `Promise.all` sobre a lista
 * inteira na montagem — 36 requisicoes (30 destaques + 6 super destaques) para
 * `job/{id}/company-logo`. Medido em producao em 26/08/2026, sobre 34 ids:
 * apenas 5 vagas tem logo, 29 respondem `null` em 13 bytes, e o endpoint leva
 * 562 ms de TTFB em media. Ou seja, 85% das requisicoes existiam so para
 * descobrir que a empresa nao tem logo. A resposta tambem nao traz
 * `cache-control`, entao isso se repetia a cada visita.
 *
 * O dado nao vem nas listas — `search-highlight-jobs` devolve
 * `companyLogo: null` nos 30 e `job?ids=` nem inclui o campo — entao a busca
 * client-side nao e redundante; o conserto definitivo e a API devolver o logo
 * (como URL, nao base64) na propria lista. Ate la, buscar so o que esta
 * visivel corta a maior parte do custo sem mudar o comportamento: o card ja
 * cai no placeholder enquanto o logo nao chega.
 *
 * @param ids ids das vagas, na mesma ordem em que os cards sao renderizados
 * @param ate quantos indices, a partir de 0, devem ter sido pedidos
 * @param jaPedidos indices ja requisitados; e mutado para nao repetir pedido
 * @returns mapa indice -> logo dos que foram buscados agora, ou null se nada
 */
export async function carregarLogos(
  ids: number[],
  ate: number,
  jaPedidos: Set<number>,
): Promise<Record<number, string> | null> {
  const alvos: number[] = [];

  for (let i = 0; i < Math.min(ate, ids.length); i++) {
    if (jaPedidos.has(i)) continue;
    jaPedidos.add(i);
    alvos.push(i);
  }

  if (alvos.length === 0) return null;

  const logos = await Promise.all(alvos.map((i) => JobService.fetchJobCompanyLogo(ids[i])));

  const parcial: Record<number, string> = {};
  alvos.forEach((indice, k) => {
    parcial[indice] = logos[k];
  });

  return parcial;
}
